import { all } from "redux-saga/effects";
import watchDashboardSaga from "./dashboard";
import watchAuthSaga from "./auth";
import watchFriendsSaga from "./friend";
import watchMemberSaga from "./member";
import watchGohonzonSaga from "./gohonzon";
import watchFamilySaga from "./family";
import watchAppontmentSaga from "./appointment";
import watchIntroductionsSaga from "./introduction/introduction";
/**
 * This method is the root of all individual sagas.
 * All the individual sagas which are added here will run in the store.
 */
export default function* rootSaga() {
  yield all([
    watchDashboardSaga(),
    watchAuthSaga(),
    watchFriendsSaga(),
    watchMemberSaga(),
    watchGohonzonSaga(),
    watchFamilySaga(),
    watchAppontmentSaga(),
    watchIntroductionsSaga(),
  ]);
}
